import { Button, Dialog } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UserProfileResult } from '@mews-commander/data-access';
import { useDeleteMutation } from './useDeleteMutation';

interface DeleteUserProps {
    userProfile: UserProfileResult;
    onSuccess?: () => void;
    onClose: () => void;
    active: boolean;
}

export const DeleteUserDialog: React.FC<DeleteUserProps> = ({ userProfile, onSuccess, onClose, active }) => {
    const { deleteMutation, isPending } = useDeleteMutation({
        userProfile,
        onSuccess,
        onSettled: onClose,
    });

    return (
        <Dialog
            title={
                <LocalizedText textKey={TextKey.RemoveUserTitle} substitutes={{ user: userProfile.fullName || '' }} />
            }
            loading={isPending}
            onClose={onClose}
            footer={{
                secondary: (
                    <Button onClick={onClose} variant="tertiary" size="medium" data-test-id="cancel" type="submit">
                        <LocalizedText textKey={TextKey.Cancel} />
                    </Button>
                ),
                primary: (
                    <Button
                        onClick={deleteMutation}
                        variant="destructive"
                        size="medium"
                        data-test-id="remove"
                        type="submit"
                    >
                        <LocalizedText textKey={TextKey.Remove} />
                    </Button>
                ),
            }}
            active={active}
        >
            <LocalizedText textKey={TextKey.RemoveUserContent} />
        </Dialog>
    );
};
